import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { RfpProfessionalQuestionListItem } from '@/components/modules/pages/rfp/professional/List/RfpProfessionalQuestionList/RfpProfessionalQuestionListItem';
import { ColorPaper } from '@/components/ui/Surface/ColorPaper';
import { Text } from '@/components/ui/Typography/Body/Text';
import ExampleIcon from '@/container/Icon/Svg/ExampleIcon';
export const RfpProfessionalQuestionListNoData = (props) => {
    const { className = '' } = props;
    const onlineQuestion = useMemo(() => ({
        id: 1,
        isAnswered: false,
        isEnd: false,
        isSelf: false,
        isUnread: false,
        question: 'RFPに記載のある期間について、開始時期をご調整頂くことは可能でしょうか？',
        questionNum: 1,
    }), []);
    return (_jsxs(ColorPaper, Object.assign({ bgColor: 'lightGray', className: clsx('flex flex-col align-center', className) }, { children: [_jsxs(Text, Object.assign({ className: clsx('text-center, mb-16'), color: 'base', isBold: true, size: 'sm' }, { children: ["\u307E\u3060\u8CEA\u554F\u304C\u3042\u308A\u307E\u305B\u3093\u3002", _jsx("br", {}), "\u8CEA\u554F\u3059\u308B\u3068\u3001\u4EE5\u4E0B\u306E\u3088\u3046\u306B\u8868\u793A\u3055\u308C\u307E\u3059\u3002"] })), _jsxs("div", Object.assign({ className: 'relative' }, { children: [_jsx(RfpProfessionalQuestionListItem, Object.assign({}, onlineQuestion, { className: 'pr-16' })), _jsx(ExampleIcon, { className: clsx('absolute top-0 -right-[5px] md:-top-[5px]', 'rotate-12', 'w-[73px] h-[21px] md:w-[123px] md:h-[35px]') })] }))] })));
};
